import gameNames from '../../hub/data/GameIds';

const initialState = {
  // array of ids of items to be highlighted
  hiddenItemsIds: [],
};

const hiddenItemsReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'HIDE_ITEMS':
      return { ...state, hiddenItemsIds: action.payload.hiddenItemsIds };
    case 'RESET_HIDDEN_ITEMS':
      return { hiddenItemsIds: [] };
    default:
      return state;
  }
};

export default hiddenItemsReducer;
